/// <reference path="../../app.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { AppFormModel } from "../models/AppFormModel";
import { ModelAdapter } from "../models/ModelAdapter";
import { BasicApplicationUrlBuilder } from "../../../../../shared/services/BasicApplicationUrlBuilder";
import { AdvertisingConsentModel } from "../../../../../shared/models/view/AdvertisingConsent";
import { User } from "../../../../../shared/models/api/User/User";

export class AppApiService {
	private readonly options: BasicAppOptions<AdvertisngConsentAppDefinition>;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<AdvertisngConsentAppDefinition>;

	constructor(options: BasicAppOptions<AdvertisngConsentAppDefinition>) {
		this.options = options;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(this.options);
	}

	public getUserIp(
		successCallback: (data: { IP: string }) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const req = {
			headers: {
				'Ocp-Apim-Subscription-Key': T.Utils.Application.getApiMSubscriptionKey(),
			},
			dataType: "json",
			url: this.applicationUrlBuilder.fullApimUrl(this.options.app.apiipaddress)
		};

		T.Utils.Ajax.fragment(
			req,
			successCallback.bind(this),
			errorCallback.bind(this)
		);
	}

	public checkConsentmanagementStatus(successCallback: (response: ApiResponse<ConsMgmntStatusResponseApi>) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: string, errorThrown?: string) => void): void {
		const url = AppUtils.Url.updateUrlParameter({ trackingReferenzId: this.options.app.trackingreferenceid }, this.applicationUrlBuilder.fullUrl(this.options.app.apiconsentmanagementstatus));

		T.Utils.Auth.getBearerToken((token: string) => {
			AppUtils.Ajax.fragment({
				method: 'GET',
				url: url,
				headers: { Authorization: `Bearer ${token}` }
			}, successCallback, errorCallback);
		});
	}

	public getProcessId(
		formId: string,
		successCallback: (data: ApiResponse<string>) => void,
		errorCallback: () => void): void {
		AppUtils.Ajax.fragment({
			method: 'GET',
			url: AppUtils.Url.updateUrlParameter({ FormId: formId }, this.applicationUrlBuilder.fullUrl(this.options.app.apiprocessid))
		}, successCallback, errorCallback);
	}

	public submitRequest(user: User,
		formModel: AppFormModel,
		advertisingConsentModel: AdvertisingConsentModel,
		successCallback: (data: ApiResponse<boolean>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const model = ModelAdapter.getConsMgmntWebApirWriteExtReqModel(user, formModel, advertisingConsentModel, this.options.app);

		const req: JQuery.AjaxSettings = {
			method: 'POST',
			url: this.applicationUrlBuilder.fullUrl(this.options.app.apiconsentmanagement),
			data: model.toJsonString()
		};
		AppUtils.Ajax.fragment(req, successCallback, errorCallback);
	}
}
